module.exports = "pegasus/assets/themelp1/charity/108.png";